import React, { Component } from 'react';

import ApplicantForm from './components/ApplicantForm/Component';
import ConfirmScolarhips from './components/ConfirmScolarships/Component';

import AgeSelector from './components/AgeSelector/Component';
import ValidScolarships from './components/ValidScolarships/Component';
import NotValidScolarships from './components/NotValidScolarships/Component';

import api from './utils/api';

import './App.css';

const MAX_SCOLARSHIPS = 2;

class App extends Component {
  constructor() {
    super();
    this.state = {applicant: {}, selected_courses: []};
    this.onAgeChange = this.onAgeChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onScolarshipChanged = this.onScolarshipChanged.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onConfirmScolarshipChanged = this.onConfirmScolarshipChanged.bind(this);
    this.onScolarshipConfirmed = this.onScolarshipConfirmed.bind(this);
    
    if (process.env.NODE_ENV !== 'production') {
      const prev_state = window.localStorage.getItem('state');

      if (prev_state) {
        this.state = JSON.parse(prev_state);
      }
    }

  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState((prev, props) => {
      const newState = { ...prev };
      newState.applicant[name] = value;
      return newState;
    });
  }

  onAgeChange(age) {
    const applicant = { ...this.state.applicant, age }
    this.setState((prev, props) => ({ ...prev, applicant, selected_courses: [], form_filled: false }));
  }

  onScolarshipChanged(id) {
    const course = this.state.courses.filter(course => course.id === id )[0];

    if (this.state.selected_courses.some((sc) => sc.id === course.id)) {
      const { selected_courses } = this.state;
      const courses = selected_courses.filter((sc) => sc.id !== course.id);
      this.setState((prev) => ({ ...prev, selected_courses: courses, form_filled: false }))
      return;
    }
    
    if (this.state.selected_courses.length < MAX_SCOLARSHIPS) {
      const selected_courses = [...this.state.selected_courses, course];
      this.setState((prev) => ({ ...prev, selected_courses, form_filled: false }))
    }
  }

  onConfirmScolarshipChanged(course, value) {
    const selected_courses = this.state.selected_courses.map((sc) => {
      if (course.id === sc.id) {
        sc.scolarship = value;
      }

      return sc;
    });

    this.setState((prev) => ({ ...prev, selected_courses }));
  }

  async onScolarshipConfirmed() {
    try {
      await api.postApplicant(this.state.applicant, this.state.selected_courses);
      this.setState((prev) => ({ ...prev, confirmed: true, error: false, applicant: {} }))
    } catch (e) {
      this.setState((prev) => ({ ...prev, error: true }))
    }

  }

  async onFormSubmit(formApplicant) {
    const new_applicant = { ...this.state.applicant, ...formApplicant };
    this.setState((prev) => ({ ...prev, applicant: new_applicant, form_filled: true }));
  }

  async componentDidMount() {
    const courses = await api.getCourses();    
    this.setState((prev, props) => ({ ...prev, courses }));
  }

  componentDidUpdate() {
    window.localStorage.setItem('state', JSON.stringify(this.state));
  }

  render() {
    return (
      <React.Fragment>
        <AgeSelector onChange={ this.onAgeChange } />
        <ValidScolarships form_filled={ this.state.form_filled } onScolarshipSelected={this.onScolarshipChanged} age={ this.state.applicant.age } courses={ this.state.courses }  selected_courses={ this.state.selected_courses } />
        { this.state.form_filled ? <ConfirmScolarhips error={ this.state.error } age={ this.state.applicant.age } confirmed={ this.state.confirmed } onScolarshipConfirmed={ this.onScolarshipConfirmed } onConfirmScolarshipChanged={ this.onConfirmScolarshipChanged } selected_courses={ this.state.selected_courses } /> : <ApplicantForm courses={ this.state.selected_courses } age={ this.state.applicant.age } onChange={this.onChange} onApplicantSubmit={this.onFormSubmit} />  }
        <NotValidScolarships age={ this.state.applicant.age } courses={ this.state.courses } />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js